module.exports = __webpack_public_path__ + "static/img/7.a3e85c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/7.png
// module id = 7sni
// module chunks = 0